"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpsellBannerMixin = void 0;
var _drywall = require("drywall");
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Heading = require("../../components/Heading/Heading.styles");
var _Text = require("../../components/Text/Text.styles");
var _TextButton = require("../../components/TextButton/TextButton.styles");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _mediaBreakpointMixin = require("../mediaBreakpointMixin");
var _mediaQueryMixin = require("../mediaQueryMixin");
var _statusDialogMixin = require("../statusDialogMixin");
var _typographyMixin = require("../typographyMixin");
var _BannerMixin = require("./BannerMixin");
var mobileCSS = (0, _styledToken.default)({
  mediaSize: 'UpsellBanner.mediaSize',
  closeSize: 'CloseButton.buttonSize',
  padding: 'UpsellBanner.padding'
}, function (_ref) {
  var mediaSize = _ref.mediaSize,
    closeSize = _ref.closeSize,
    padding = _ref.padding;
  return (0, _styledComponents.css)(["flex-direction:column;align-items:flex-start;min-height:", "px;padding-left:", "px;padding-right:", "px;position:relative;", "{position:absolute;top:", "px;left:", "px;}", "{position:absolute;top:", "px;right:", "px;}", "{margin:0;& ", "{text-align:start;}}"], 2 * padding + mediaSize, 2 * padding + mediaSize, 2 * padding + closeSize, _drywall.Toast.Icon, padding, padding, _drywall.Toast.Close, padding, padding, _drywall.Toast.Action, _TextButton.StyledTextButton);
});
var showBodyCSS = (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('showBody', function (_ref2) {
  var showBody = _ref2.showBody;
  return (0, _styledComponents.css)(["", " + ", "{display:", ";}"], _Heading.StyledHeading, _Text.StyledText, showBody ? 'initial' : 'none');
});
var colorCSS = function colorCSS(props) {
  var background = props.background;
  return (0, _styledToken.default)({
    backgroundColor: "colors." + background,
    boxShadow: 'Upsell.boxShadow'
  }, {
    defaultValue: ''
  }, function (tokens) {
    var styles = ["background: " + tokens.backgroundColor + ";"];
    if (background === 'backgroundBrand') {
      styles.push((0, _statusDialogMixin.statusDialogMixin)(Object.assign({
        inverse: true
      }, props)));
      // Need to add BannerMixin again to override statusDialogMixin values
      styles.push((0, _BannerMixin.BannerMixin)(props));
    }
    if (background === 'backgroundWhite') {
      styles.push("box-shadow: " + tokens.boxShadow + ";");
    }
    return styles;
  });
};

/** @class UpsellBannerMixin */
/** @method */
var UpsellBannerMixin = function UpsellBannerMixin(props) {
  return (0, _styledToken.default)({
    fontType: 'UpsellBanner.fontType',
    mediaSize: 'UpsellBanner.mediaSize'
  }, function (tokens) {
    return (0, _styledComponents.css)(["align-items:center;border:0;", "{display:inline;", "}", "", "{height:", "px;width:", "px;}", "", "{flex-shrink:1;}", " @media ", "{", "}", " ", ""], _Heading.StyledHeading, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: tokens.fontType
    }, props)), _drywall.Toast.Icon, _drywall.Toast.Icon, tokens.mediaSize, tokens.mediaSize, _drywall.Toast.Body, _drywall.Toast.Body, colorCSS(props), (0, _mediaBreakpointMixin.mediaBreakpointMixin)('sm_lte'), mobileCSS(props), showBodyCSS(props), (0, _mediaQueryMixin.mediaQueryMixin)(function (mediaProps) {
      return showBodyCSS(Object.assign({}, mediaProps));
    }));
  })(props);
};
exports.UpsellBannerMixin = UpsellBannerMixin;